<template>
  <div class="btns">
    <div>
      <el-button size="mini" type="primary" plain @click="viewDeed"
        >查看委托单</el-button
      >
    </div>
    <!-- 确认收样-->
    <template v-if="showGetSample">
      <!-- <div>
        <el-button
          size="mini"
          type="primary"
          plain
          @click="$emit('viewLogistics')"
          >查看寄样快递信息</el-button
        >
      </div> -->
      <div>
        <el-button
          size="mini"
          type="danger"
          plain
          @click="confirmSample"
          :loading="confirmSampleLoading"
          >已收样开始检测</el-button
        >
      </div>
    </template>
    <!--检查完成之后-->
    <!-- <template v-if="showCheckComplete">
      <div>
        <el-button
          size="mini"
          type="primary"
          plain
          @click="$emit('addRetreatLogistics')"
          >填写退样快递信息</el-button
        >
      </div>
      <div>
        <el-button
          size="mini"
          type="primary"
          plain
          @click="$emit('viewRetreatLogistics')"
          >查看退样快递信息</el-button
        >
      </div>
    </template> -->
    <div v-if="showUploadReport">
      <el-button size="mini" type="primary" plain @click="$emit('uploadReport')"
        >上传/查看检测报告</el-button
      >
    </div>
    <div v-if="showFinish">
      <el-button
        size="mini"
        type="primary"
        plain
        @click="checkComplete"
        :loading="checkCompleteLoading"
        >检测完成</el-button
      >
    </div>
    <div v-if="showCompletePay">
      <el-button
        size="mini"
        type="primary"
        plain
        @click="payComplete"
        :loading="payCompleteLoading"
        >完成支付</el-button
      >
    </div>
    <!-- <div v-if="showRefundExamine">
      <el-button
        size="mini"
        type="primary"
        plain
        @click="$emit('refundExamine')"
        >退款审核</el-button
      >
    </div> -->
    <div v-if="showDiscard">
      <el-button size="mini" type="primary" plain @click="discardDeed"
        >废弃此订单</el-button
      >
    </div>
    <div v-if="showUpdatePrice">
      <el-button size="mini" type="primary" plain @click="updatePrice"
        >修改订单价格</el-button
      >
    </div>
  </div>
</template>
<script>
import { updateStrictOrderStatus, updateOrderPayStatus } from "@/api/mall";
import { discardDeedById } from "@/api/userCenter";
import {
  // DEED_ORDER_SUCCESS,
  DEED_ORDER_FINISH,
  DEED_ORDER_CHECKING,
  DEED_ORDER_WAITSAMPLE,
  DEED_ORDER_REPORT,
  // PAYTYPE_XY,
  // PAYSTATUS_SUCCESS,
  // PAYSTATUS_NO,
  ORDER_PAY_STATUS,
} from "@/constant/index";
import { REFUND_STATUS_MAP } from "@/constant/dict";
export default {
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      confirmSampleLoading: false,
      checkCompleteLoading: false,
      payCompleteLoading: false,
    };
  },
  computed: {
    // 确认收样
    showGetSample() {
      const { orderCheckStatus } = this.row;
      return orderCheckStatus === DEED_ORDER_WAITSAMPLE;
    },
    // 废弃此订单按钮
    showDiscard() {
      const { orderCheckStatus } = this.row;
      return orderCheckStatus < DEED_ORDER_FINISH;
    },
    // 检测完成
    showCheckComplete() {
      const { orderCheckStatus } = this.row;
      return orderCheckStatus >= DEED_ORDER_REPORT;
    },
    // 检测完成
    showFinish() {
      const { orderCheckStatus } = this.row;
      return (
        orderCheckStatus >= DEED_ORDER_REPORT &&
        orderCheckStatus < DEED_ORDER_FINISH
      );
    },
    // 上传检测报告
    showUploadReport() {
      const { orderCheckStatus } = this.row;
      const arr = [DEED_ORDER_CHECKING, DEED_ORDER_REPORT, DEED_ORDER_FINISH];
      return arr.includes(orderCheckStatus);
    },
    // 退款审核按钮
    showRefundExamine() {
      const { saleStatus } = this.row;
      return saleStatus === REFUND_STATUS_MAP.pending;
    },
    // 完成支付
    showCompletePay() {
      const { orderPayStatus } = this.row;
      return +orderPayStatus < ORDER_PAY_STATUS.offlinePaid;
    },
    // 修改价格
    showUpdatePrice() {
      const { orderPayStatus } = this.row;
      return +orderPayStatus < ORDER_PAY_STATUS.offlinePaid;
    },
  },
  // computed:{},
  methods: {
    // 查看详情
    viewDeed() {
      this.$emit("viewDeed");
    },
    // 废弃此订单
    async discardDeed() {
      await this.$confirm("确定废弃此订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      await this.$axios.post(discardDeedById, {
        orderId: this.row.checkmallOrderMainId,
      });
      this.$message.success("废弃订单成功");
      this.$emit("refresh");
    },
    // 修改价格
    updatePrice() {
      this.$emit("updatePrice");
    },
    // 确认收样
    async confirmSample() {
      this.confirmSampleLoading = true;
      await this.changeStatus(
        DEED_ORDER_CHECKING,
        "确认收样，开始检测"
      ).finally(() => {
        this.confirmSampleLoading = false;
      });
    },
    // 检测完成
    async checkComplete() {
      this.checkCompleteLoading = true;
      await this.changeStatus(DEED_ORDER_FINISH, "检测完成").finally(() => {
        this.checkCompleteLoading = false;
      });
      this.$emit("refresh");
    },
    async changeStatus(status, tip) {
      try {
        await this.$axios.post(updateStrictOrderStatus, {
          checkmallOrderMainId: this.row.checkmallOrderMainId,
          orderCheckStatus: status,
        });
        this.$message.success(tip);
        this.$emit("refresh");
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },

    async payComplete() {
      this.payCompleteLoading = true;
      await this.$axios
        .put(updateOrderPayStatus, {
          checkmallOrderMainId: this.row.checkmallOrderMainId,
          orderPayStatus: ORDER_PAY_STATUS.offlinePaid,
        })
        .finally(() => {
          this.payCompleteLoading = false;
        });
      this.$message.success("完成支付");
      this.$emit("refresh");
    },
  },
};
</script>
<style lang="scss" scoped>
.btns {
  padding-top: 10px;
  > div {
    margin-bottom: 10px;
    text-align: center;
  }
  /deep/ .el-button {
    width: 130px;
  }
}
</style>
